import React from 'react';
import * as _ from 'lodash';
import { FieldImageService } from '../../../services/FieldImages';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormElement } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { TrashIcon } from '../../icons/TrashIcon';
import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';

/**
 * @description 作業安全指示書画像ドロップダウン
 *              作業予定、実績登録、編集画面で使用
 */
export class FieldImagesKeyplanDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      loaded: false,
      allLoaded: false,
      opened: false, // 開閉フラグ
      selected: null, // 選択キープラン情報
      options: [], // 取得キープラン情報
      // 検索条件キープラン名
      condition: {
        name: '',
      },
      offset: 0,
      previousSelected: null,
      temporarySelected: null,
      isLoading: true, // ロード中フラグ
    };

    this.initializeLoaded = false; // 編集画面用初期ロードフラグ

    this.id = Math.floor(Math.random() * 100000);
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.keyplanOpen = this.keyplanOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getFieldImageskeyplan = this.getFieldImageskeyplan.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
    this.observer = null;
    this.keyplanObjRef = React.createRef();
  }

  componentDidMount() {
    this.getFieldImageskeyplan();
    // キープランの修正を監視するための処理を行う
    this.initObserve();
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }

    if (prevProps.keyplanCode !== this.props.keyplanCode) {
      /**
       * WorkRegister、WorkEditでworkGroupId(日付、協力会社、職種、職長)
       * 変更時、該当するkeyplanCodeをselectする
       */
      if (this.initializeLoaded === true) {
        if (_.isUndefined(this.props.keyplanCode)) {
          this.setState({
            selected: null,
            previousSelected: null,
            temporarySelected: null,
          });
        } else {
          const selectedItem = this.state.options.find(
            item => item.category_code === this.props.keyplanCode
          );
          if (selectedItem) {
            this.setState({
              temporarySelected: this.props.keyplanCode,
              selected: this.props.keyplanCode,
            });
          } else if (!selectedItem && this.props.keyplanCode !== '') {
            /**
             *  絞り込み検索などでpropからのkeyplanCodeに該当するデータがない場合
             *  絞り込み検索を解除して全件取得する
             *
             *  この処理はキープランのテンプレート画像、登録最大数が20件で、
             *  getFieldImageskeyplanの最低取得データ数が30件(20件より多い)という前提。
             */
            this.setState(
              {
                temporarySelected: this.props.keyplanCode,
                selected: this.props.keyplanCode,
                condition: {
                  name: '',
                },
                loaded: false,
                allLoaded: false,
                isLoading: true,
              },
              () => {
                this.getFieldImageskeyplan();
              }
            );
          }
        }
      } else {
        // 編集画面遷移直後かつキープランが設定されている時実行
        if (
          !_.isUndefined(this.props.keyplanCode) &&
          this.props.keyplanCode !== ''
        ) {
          this.initializeLoaded = true;
          this.setState({ selected: this.props.keyplanCode });
        }
      }

      // ×ボタンを押下した場合
      if (this.props.keyplanCode === '') {
        this.setState({
          selected: null,
          previousSelected: null,
          temporarySelected: null,
        });
      }
    }
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  initObserve() {
    // console.log('FieldImagesKeyplan.jsx', 'initObserve');
    // keyplan-image, keyplan-image-val, keyplan-image-objの変更完了すると
    // keyplan-image-changedを変更しているのでkeyplan-image-changedをを監視
    const keyplancCanged = document.getElementById('keyplan-image-changed');

    // オブザーバインスタンスを作成
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(() => {
        this.props.keyplanObserver();
      });
    });

    // オブザーバの設定
    const config = { attributes: true };

    // 対象ノードとオブザーバの設定を渡す
    this.observer.observe(keyplancCanged, config);
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    const state = this.state;
    state.opened = false;
    state.selected = state.previousSelected;
    state.temporarySelected = state.previousSelected;
    this.setState(state);
  };

  /**
   * @description ドロップダウンの開閉状態を設定
   */
  handleOpen = () => {
    const state = this.state;
    state.opened = !this.state.opened;
    // 初期化
    if (state.opened) {
      state.previousSelected = state.selected;
      state.temporarySelected = state.selected;
      state.loaded = true;
    } else {
      state.selected = state.previousSelected;
      state.temporarySelected = state.previousSelected;
    }
    this.setState(state);
  };

  /**
   * @description 現場配置計画へ遷移
   */
  keyplanOpen = () => {
    // this.props.readOnly=trueでもキープラン画面を開く必要がある
    if (!this.props.imageUrl) {
      return;
    }

    // console.log('FieldImagesKeyplan.jsx', 'keyplanOpen', this.props.keyplanCode);
    window.open(
      `${window.location.origin}/conference/0:1/0/0/KeyplanLayout:${
        this.props.keyplanCode
      }/0:1`
    );
    this.props.setEditFlag();
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  /**
   * @description キープランを検索
   */
  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        selected: null,
        isLoading: true,
      },
      () => {
        this.getFieldImageskeyplan();
      }
    );
  };

  /**
   * キープランの最大登録数20件、REQUEST_PARAMS.parentLimitが30件なので
   * InfinityScrollLoadするケースが恐らくない
   */
  handleInview(notify) {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      // this.getFieldAItems(notify); 用途、定義不明。念のためコメントアウト
    } else if (this.state.allLoaded) {
      notify();
    }
  }

  /**
   * @description ラジオボタンチェック
   * @param {object} option キープラン情報
   */
  handleSelectedRow = (id, checked) => {
    let selected = null;
    if (checked) {
      selected = id;
    }
    this.setState({ temporarySelected: selected }, () => {
      this.setValue();
    });
  };

  setValue = () => {
    const state = this.state;
    if (_.isNull(state.temporarySelected)) {
      this.props.deleteKeyPlan();
    } else {
      state.selected = state.temporarySelected;
      state.previousSelected = state.selected;
      this.setState(state);

      const checked = _.find(this.state.options, {
        category_code: this.state.selected,
      });
      this.props.set(checked);
      this.keyplanObjRef.current.value = null;
    }
    this.setState({ opened: false });
  };

  clearSelectedRow = () => {
    this.setState({ selected: null, temporarySelected: null }, () => {
      this.setValue();
    });
  };

  /**
   * @description キープラン情報取得
   * @param {object} init 再読み込み設定
   *                      検索キープラン名を設定時に使用
   */
  getFieldImageskeyplan(notify = () => {}) {
    if (this.state.loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const params = {
      field_id: this.state.fieldId,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
    };

    /**
     * category_code、category_codesでの検索も可能
     */
    FieldImageService.keyplan(this.state.fieldId, params).then(response => {
      if (response.result) {
        const _fieldImages = response.data.entities.field_images;
        const allLoaded = _.size(_fieldImages) < params.limit;
        const fieldImages = _.filter(_fieldImages, { display_flag: 1 });
        const options = this.state.options;
        _.each(fieldImages, image => {
          if (
            _.findIndex(options, { category_code: image.category_code }) < 0
          ) {
            options.push(image);
          }
        });
        this.setState(
          {
            options,
            loaded: true,
            allLoaded,
            isLoading: false,
          },
          () => {
            this.props.setLoadedKeyPlanData(options);
          }
        );
      }
      notify();
    });
  }

  render() {
    const getName = () => {
      let name = 'キープランを選択';
      const option = _.find(this.state.options, {
        category_code: this.state.temporarySelected
          ? this.state.temporarySelected
          : this.state.selected,
      });
      if (option) {
        name = `${option.label} : ${option.comment}`;
      }
      return name;
    };
    return (
      <FormElement
        info={
          this.props.imageUrl &&
          !this.props.readOnly &&
          '※画像をクリックすると編集が可能です。'
        }
      >
        {!this.props.readOnly && (
          <div id='form-dropdown' className='dropdown-multi-select'>
            <div
              className={
                this.state.opened
                  ? 'dropdown-multi-select__header show'
                  : 'dropdown-multi-select__header'
              }
              ref={this.parent}
            >
              <div
                id='form-dropdown-btn'
                className='dropdown-select'
                onClick={() => this.handleOpen()}
              >
                <span className='dropdown-select__txt'>{getName()}</span>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        value={this.state.condition.name}
                        onChange={e => this.setCondition(e)}
                      />
                    </div>
                    {this.props.isOptional && (
                      <div className='dropdown-single-select__item'>
                        <FormDropdownClearButton
                          onClick={this.clearSelectedRow}
                        />
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected ===
                                option.category_code
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-field-images-keyplan'
                              column='category_code'
                            >{`${option.label} : ${
                              option.comment
                            }`}</FormDropdownRadio>
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.handleInview}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {this.props.readOnly &&
          this.props.imageUrl &&
          (this.props.isFormListDefault ? (
            <div>{getName()}</div>
          ) : (
            <input disabled type='text' value={getName()} />
          ))}
        <div className='form-list__element-keyplan'>
          <div
            className={
              this.props.imageUrl && !this.props.readOnly
                ? 'form-list__element-keyplan-image form-list__element-keyplan-image--selected'
                : 'form-list__element-keyplan-image'
            }
            onClick={() => this.keyplanOpen()}
          >
            <img
              id='keyplan-image'
              src={this.props.imageUrl}
              alt=''
              key={_.random(1, true)}
            />
            <input id='keyplan-image-val' type='hidden' />
            <input
              id='keyplan-image-obj'
              type='hidden'
              value={_.defaultTo(this.props.imageJson, '')}
            />
            <input
              id='keyplan-image-obj-tmp'
              type='hidden'
              ref={this.keyplanObjRef}
            />

            {/* MutationObserver用のdiv */}
            <div id='keyplan-image-changed' />
          </div>
          {!this.props.readOnly && this.props.imageUrl && (
            <button
              className='form-list__element-keyplan-button--delete'
              onClick={() => this.props.deleteKeyPlan()}
            >
              <TrashIcon className='icon--2_4x form-list__trash-icon' />
            </button>
          )}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldImagesKeyplan.jsx